import { Button, Grid, IconButton, Typography } from "@mui/material";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import WSDataGrid, { IColumns } from "../../../Components/DataGrid/WSDataGrid";
import { WSIcons } from "../../../commonFunctions/iIcons";
import { AccountListDrawer } from "./AccountListDrawer";
import { PaymentPostingDrawer } from "./PamentPostingDrawer";
import { PaymentSearchDrawer } from "./PaymentSearchDrawer";
import { AmountPaidInfo } from "./AmountPaid";

export const PaymentList: React.FC<any> = React.memo((props) => {
  const [cartOpen, setCartOpen] = useState(false);
  const [openAmountPaid, setOpenAmountPaid] = useState(false);  

  const navigate = useNavigate();
  const handleCartClick = () => {
    setCartOpen(true);
  };

  const handleCartClose = () => {
    setCartOpen(false);
  };

  const columns: IColumns[] = [
    {
      header: "Date",
      fieldName: "workLocationName",
      tooltip: true,
    },
    {
      header: "Payment Type",
      fieldName: "address",
      tooltip: true,
    },
    {
      header: "Receipt No",
      fieldName: "address",
      tooltip: true,
    },
    {
      header: "Amount",
      fieldName: "address",
      tooltip: true,
    },
    {
      header: "Mapped Amount",
      fieldName: "address",
      tooltip: true,
    },
    {
      header: "UnMapped Amount",
      fieldName: "address",
      tooltip: true,
    },
    {
      header: "User",
      fieldName: "address",
      tooltip: true,
    },
    {
      header: "Remark",
      fieldName: "address",
      tooltip: true,
    },
   
  ];

  const handleClick = (path: string) => {
    navigate(path);
  };
  const handleAmountPaidClick = () => {
    setOpenAmountPaid(true); 
  };
  const handleAmountPaidClose = () => {
    setOpenAmountPaid(false); 
  };
  return (
    <Grid container direction="column" sx={{ minHeight: "100vh" }}>
      {/* Header Section */}
      <Grid item>
        <Grid
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "16px",
          }}
        >
          {/* Title on the left */}
          <Typography variant="h6" sx={{ fontWeight: "bold", color: "green" }}>
            Payment List
          </Typography>
          <Grid sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <IconButton>
              <WSIcons.SyncIcon />
            </IconButton>
            <IconButton onClick={handleCartClick}>
              <WSIcons.SearchIcon />
            </IconButton>
            <PaymentSearchDrawer open={cartOpen} onClose={handleCartClose} />
            <IconButton>
              <WSIcons.CloseIcon
                sx={{ backgroundColor: "red", color: "white" }}
                onClick={() => handleClick("/accountlisting")}
              />
            </IconButton>
          </Grid>
        </Grid>
      </Grid>
      <Grid item>
        <Grid
          container
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "16px",
            border: "1px solid lightgray",
          }}
        >
          <Grid item xs={2}>
            <Typography variant="body1">Account Name</Typography>
          </Grid>

          <Grid item xs={2}>
            <Typography >Bad Debts[Bad Debts]</Typography>
          </Grid>

          <Grid item xs={1}>
            <Typography variant="body1">Due Balance</Typography>
          </Grid>

          <Grid item xs={1}>
            <Typography variant="body1">0</Typography>
          </Grid>
        </Grid>
      </Grid>

      {/* DataGrid Section */}
      <Grid item sx={{ flex: 1 }}>
        <WSDataGrid id="itemGrid" title="" columns={columns} />
      </Grid>
      <Grid
        item
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          padding: "16px",
        }}
      >
        <Typography>Balance:</Typography>
        <Typography>0.00</Typography>
      </Grid>
      {/* Footer Section */}
      <Grid
        item
        sx={{
          backgroundColor: "#333",
          padding: "1rem",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        {/* Icon on the left */}
        <Grid item>
          <WSIcons.GTranslateIcon sx={{ color: "white" }} />
        </Grid>

        {/* Buttons on the right */}
        <Grid item sx={{ display: "flex", marginLeft: "auto" }}>
        <Button
            variant="outlined"
            sx={{
              width: "13rem",
              color: "white",
              borderColor: "green",
            }}
          >
            Print Preview
          </Button>
          <Button
            variant="outlined"
            sx={{
              width: "13rem",
              color: "white",
              borderColor: "green",
            }}
          >
            Print 
          </Button>
          <Button
            variant="outlined"
            sx={{
              ml: 2, // Adds space between the buttons
              color: "white",
              borderColor: "green",
            }}
          >
            Recall
          </Button>
          <Button
            variant="contained"
            sx={{
              ml: 2, // Adds space between the buttons
              backgroundColor: "green",
              "&:hover": {
                backgroundColor: "#388e3c",
              },
            }}
            onClick={handleAmountPaidClick}>
            New
          </Button>
        </Grid>
      </Grid>
      <AmountPaidInfo open={openAmountPaid}  onClose={handleAmountPaidClose} />

    </Grid>
  );
});
